import {
  supabaseAuthenticatedApi,
  workspaceBackendUrl,
} from "../../../../components/SupabaseClient";

export const MUTATION_CHUNK_SIZE = 10;
export const MUTATION_TIMEOUT = 60000;
export const mutationSucceeded = (result, action) =>
  result?.http_status === 200 &&
  (action === "cancel"
    ? ["cancelled", "already_cancelled"].includes(result.outcome)
    : result.outcome === "record_deleted");

// Never infer a different action after a transition or a transport timeout.
export async function mutateJobs(
  ids,
  action,
  single = false,
  isActive = () => true,
) {
  const results = [];
  for (let offset = 0; offset < ids.length; offset += MUTATION_CHUNK_SIZE) {
    if (!isActive()) break;
    const chunk = ids.slice(offset, offset + MUTATION_CHUNK_SIZE);
    try {
      const response = await supabaseAuthenticatedApi.request(
        "DELETE",
        workspaceBackendUrl,
        single
          ? `/jobs/${encodeURIComponent(chunk[0])}?action=${action}`
          : "/jobs/batch",
        single ? null : { job_ids: chunk, action },
        MUTATION_TIMEOUT,
      );
      const body = await response.json();
      const byId = new Map(
        (single ? [body] : body.results || []).map((result) => [
          result.job_id,
          result,
        ]),
      );
      chunk.forEach((job_id) =>
        results.push(
          byId.get(job_id) || {
            job_id,
            outcome: "failed",
            errors: [
              "No result returned. Refresh and retry with the same action.",
            ],
          },
        ),
      );
    } catch (error) {
      const detail =
        typeof error.data?.detail === "string"
          ? error.data.detail
          : error.message;
      chunk.forEach((job_id) =>
        results.push({
          job_id,
          outcome: "failed",
          errors: [
            detail || "Request failed.",
            "The action may still be running. Refresh before retrying with the same action.",
          ],
        }),
      );
      // Do not queue additional destructive requests after an uncertain response.
      ids.slice(offset + chunk.length).forEach((job_id) =>
        results.push({
          job_id,
          outcome: "failed",
          errors: ["Not attempted after the preceding request failed."],
        }),
      );
      break;
    }
  }
  return results;
}
